import React, { useState, useEffect } from 'react';
import { Confirm } from './Confirm';
import { ConfirmDetails } from './ConfirmDetails';
import { useResponsive } from '../../hooks/useResponsive';

export const ConfirmWrapper = () => {
  const { isMobile, isTablet } = useResponsive();
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  // Prevent hydration mismatch by showing a loading state on first render
  if (!isClient) {
    return <div className="w-full min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
    </div>;
  }

  // Render ConfirmDetails for mobile and tablet screens, Confirm for desktop
  // Using lg breakpoint (1024px) as the cutoff
  return (isMobile || isTablet) ? <ConfirmDetails /> : <Confirm />;
};
